"use strict";

import Vue from "vue";
import axios from "axios";

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

let config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  timeout: 60 * 1000 // Timeout
  // withCredentials: true, // Check cross-site Access-Control
};

const _axios = axios.create(config);

_axios.interceptors.request.use(
  function(config) {
    // Do something before request is sent
    if (config.url.indexOf("/app") === 0) {
      config.baseURL = process.env.VUE_APP_API_URL;
      config.headers.Authorization = localStorage.getItem("api_token");
      // localStorage.getItem("token")
    } else {
      config.baseURL = "";
    }
    return config;
  },
  function(error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

// Add a response interceptor
_axios.interceptors.response.use(
  function(response) {
    // Do something with response data
    if (response.config.url.indexOf("/app/api") > 0) {
      // api 请求 code 不是 200 的都是失败，走 catch 捕捉
      if (response.data.code !== 200) {
        const message = response.data.message || "操作失败";
        throw Error(message);
      }
    }
    return response.data;
  },
  function(error) {
    console.error("request error:", error);
    // Do something with response error
    return Promise.reject(error);
  }
);

Plugin.install = function(Vue) {
  window.axios = _axios;
  Object.defineProperties(Vue.prototype, {
    $axios: {
      get() {
        return _axios;
      }
    }
  });
};

Vue.use(Plugin);

export default _axios;
